import React from 'react';
import { SVGProps } from './type';

export const IconMultiAccount2 = ({ fill }: SVGProps) => (
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M13 1.999H11.001a3 3 0 0 0 -3 3V6a3 3 0 0 0 3 3v1.999h-3a3 3 0 0 0 -3 3V15a3 3 0 0 0 -3 3v0.999a3 3 0 0 0 3 3h1.999a3 3 0 0 0 3 -3V18a3 3 0 0 0 -3 -3v-1.001c0 -0.552 0.449 -1.001 1.001 -1.001h8c0.553 0 1.001 0.449 1.001 1.001V15a3 3 0 0 0 -3 3v0.999a3 3 0 0 0 3 3h1.999a3 3 0 0 0 3 -3V18a3 3 0 0 0 -3 -3v-1.001a3 3 0 0 0 -3 -3h-3V9a3 3 0 0 0 3 -3v-1.001a3 3 0 0 0 -3 -3m-3 3c0 -0.552 0.449 -1.001 1.001 -1.001h1.999c0.553 0 1.001 0.449 1.001 1.001V6a1.001 1.001 0 0 1 -1.001 0.999H11.001A1.001 1.001 0 0 1 10 6zm-5 12a1.001 1.001 0 0 0 -1.001 1.001v0.999c0 0.552 0.449 1.001 1.001 1.001h1.999a1.001 1.001 0 0 0 1.001 -1.001V18a1.001 1.001 0 0 0 -1.001 -1.001zm11 1.001c0 -0.552 0.449 -1.001 1.001 -1.001h1.999c0.553 0 1.001 0.449 1.001 1.001v0.999a1.001 1.001 0 0 1 -1.001 1.001h-1.999a1.001 1.001 0 0 1 -1.001 -1.001z"
    fill={fill}
  />
);
